// Rails CSRF token for fetch/XHR headers ("X-CSRF-Token") and hand-built
// form posts ("authenticity_token").
export function csrfToken() {
  var meta = document.querySelector("meta[name='csrf-token']")
  return meta ? meta.content : ""
}

/*
 *	Returns a list of params used for sorting/filtering
 */
export function url_add_param(url, param, value) {
  var hash = {}
  var parser = document.createElement("a")

  parser.href = url

  var parameters = parser.search.split(/\?|&/)

  for (var i = 0; i < parameters.length; i++) {
    if (!parameters[i]) continue

    var ary = parameters[i].split("=")
    hash[ary[0]] = ary[1]
  }

  hash[param] = value

  var list = []
  Object.keys(hash).forEach(function (key) {
    list.push(key + "=" + hash[key])
  })

  parser.search = "?" + list.join("&")
  return parser.href
}

/*
 *	Remove a specific param/value pair from a url
 */
export function url_remove_param(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split("?")
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "="
    var pars = urlparts[1].split(/[&;]/g)

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }

    url = urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "")
    return url
  } else {
    return url
  }
}

export function url_get_param(param) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=")

    if (sParameterName[0] === param) {
      return sParameterName[1] === undefined ? true : sParameterName[1]
    }
  }
}

export function get_base_url() {
  var re = new RegExp(/^.*\//)
  return re.exec(window.location.href)
}

/*
 *	Converts string of text into slug
 */
export function text_to_slug(Text) {
  return Text.toLowerCase()
    .replace(/\.[^/.]+$/, "")
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "")
}

/*
 *	Takes this_string into This String
 */
export function humanize(Text) {
  return Text.replace(/^[\s_]+|[\s_]+$/g, "")
    .replace(/[_\s]+/g, " ")
    .replace(/^[a-z]/, function (m) {
      return m.toUpperCase()
    })
}

/*
 *	Dollars to cents
 */
export function dollars_to_cents(amount) {
  return amount * 100.0
}

/*
 *  Displays loading message on the page
 */
export function showLoadingMessage(message) {
  $("body")
    .addClass("loading")
    .prepend('<div class="loading-messages">' + message + "...</div>")
  return
}

/*
 *  Removes loading message from the page
 */
export function hideLoadingMessage() {
  $(".loading-messages").remove()
  $("body").removeClass("loading")
  return
}

/*
 *  Extracts on_sale and sale_campaign params from url
 */
export function get_sale_campaign_params() {
  return {
    on_sale: url_get_param("on_sale"),
    sale_campaign: url_get_param("sale_campaign"),
  }
}

/*
 *  Displays flash notice similar to 'app/views/partials/notices'
 */
// Toasts auto-hide by default; pass { persist: true } for results that arrive
// asynchronously (asset scan outcomes) — those get missed when they vanish
// while the user is looking elsewhere. The stack is bounded either way: once
// full, the oldest notice makes room for the newest. 5 fits a full scan-cycle
// summary (unpacked/scanned/deduped/awaiting/rejected) without loss.
var MAX_VISIBLE_NOTICES = 5
var NOTICE_TIMEOUT_MS = 8000

export function displayFlashMessage(type, msg, options) {
  // expects a type string argument that aligns with bootstrap bg colors
  var persist = !!(options && options.persist)
  var $container = $("#notices")
  if (!$container.length) {
    $container = $(
      '<div id="notices" class="fixed-bottom p-4" style="z-index: 1999;"></div>'
    )
    $("body").prepend($container)
  }

  var $toasts = $container.find(".toast")
  if ($toasts.length >= MAX_VISIBLE_NOTICES) {
    $toasts
      .slice(0, $toasts.length - MAX_VISIBLE_NOTICES + 1)
      .closest(".toast-container")
      .addBack()
      .remove()
  }

  var $toast = $(
    `<div class="toast bg-${type} show mb-2" role="alert" data-bs-autohide="false">
      <div class="d-flex">
        <div class="toast-body"></div>
        <button class="btn-close me-2 m-auto flex-shrink-0" data-bs-dismiss="toast" aria-label="Close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>`
  )
  // Text, never HTML: messages carry creator-controlled strings (filenames,
  // asset names, server error text) that must not be parsed as markup —
  // mirrors the ERB escaping in partials/_notices.html.erb.
  $toast.find(".toast-body").text(msg)
  $container.append($toast)

  if (!persist) {
    setTimeout(function () {
      $toast.remove()
    }, NOTICE_TIMEOUT_MS)
  }
}

/*
 * Allows forms to update positioning when rendered
 */
export function updatePositions($object) {
  $object.each(function (index, el) {
    var $el = $(el)
    var $positionInput = $el.find("input[name*='position']")
    $positionInput.val(index + 1)
  })
}

/*
 * Opens up form upon initialization
 */
export function setUpCollapsibleForm($insertedItem) {
  var $collapsible = $insertedItem.find(
    '[class*="js-"]:not(.js-collapse-toggler)[class*="-collapse"]'
  )
  var $collapseToggler = $insertedItem.find(".js-collapse-toggler")
  var $id = $insertedItem
    .find('input[class*="js-"]')
    .first()
    .attr("id")
    .replace(/(question|title)/, "collapse")
  $collapsible.attr("id", $id).addClass("show")
  $collapseToggler.attr({ href: `#${$id}`, "aria-expanded": true })
}
